import { render, staticRenderFns } from "./InternalMovingArticles.vue?vue&type=template&id=40cd4ece&scoped=true"
import script from "./InternalMovingArticles.vue?vue&type=script&lang=js"
export * from "./InternalMovingArticles.vue?vue&type=script&lang=js"
import style0 from "./InternalMovingArticles.vue?vue&type=style&index=0&id=40cd4ece&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40cd4ece",
  null
  
)

export default component.exports